//#region src/deliverect_order_type.ts
var DeliverectOrderType = /* @__PURE__ */ function(DeliverectOrderType) {
	DeliverectOrderType["PickUp"] = "1";
	DeliverectOrderType["Delivery"] = "2";
	DeliverectOrderType["EatIn"] = "3";
	DeliverectOrderType["Curbside"] = "4";
	return DeliverectOrderType;
}(DeliverectOrderType || {});
//#endregion
export { DeliverectOrderType };

//# sourceMappingURL=deliverect_order_type.js.map